import React from "react";

const CheckboxLabelPosition = {
  Right: "right",
  Left: "left",
};

const wrapperClasses = "flex items-center p-2 rounded h-10";
const inputClasses = "w-4 h-4 rounded-xs border border-primary bg-white cursor-pointer";

const Checkbox = ({ label, position, field, ...restProps }) => {
  const checkboxId = field?.name || restProps?.id || "checkbox";
  const isRight = position === CheckboxLabelPosition.Right;

  return (
    <div className="form-field" key={restProps?.key}>
      <div className={`${wrapperClasses} ${isRight ? "flex-row-reverse" : ""}`}>
        <input
          id={checkboxId}
          type="checkbox"
          className={inputClasses}
          {...field}
          {...restProps}
          checked={restProps?.checked ?? field?.value}
        />

        <label
          htmlFor={checkboxId}
          className={`form-check-label mb-0 ${
            position === CheckboxLabelPosition.Right ? "mr-2" : "ml-2"
          }`}
        >
          {label}
        </label>
      </div>
    </div>
  );
};

Checkbox.defaultProps = {
  label: "Checkbox",
  position: CheckboxLabelPosition.Left,
};

export default Checkbox;